<script setup>
import { useFAQStore } from '~/stores/faq'
const { $label, $sentryCaptureException, $toast, payload } = useNuxtApp()
const FAQStore = useFAQStore()
const route = useRoute()

function handleError(error) {
  $sentryCaptureException(error)
  $toast.error($label('messages.errorOccuredMessage'))
}

const categories = computed(() => FAQStore.categories)
const { error: categoriesError } = await useAsyncData('faqCategories', () =>
  FAQStore.getCategories()
)

if (categoriesError.value) {
  handleError(categoriesError.value)
}

const categorySlug = computed(
  () => route.params.slug || categories.value?.[0]?.slug
)
const activeCategory = computed(() => {
  return (
    categories.value.find(
      (category) => category?.slug === categorySlug.value
    ) || categories.value[0]
  )
})

const activeQuestion = computed(() => route.query.question)

const { error: faqError } = await useAsyncData(
  `FAQs-${categorySlug.value}`,
  () => FAQStore.getFAQ(activeCategory.value.id),
  {
    getCachedData: (slug) => {
      return payload.data?.[slug] || payload.static?.[slug]
    }
  }
)

if (faqError.value) {
  handleError(faqError.value)
}

useHead({
  htmlAttrs: {
    lang: 'nl-NL',
    itemscope: '',
    itemtype: 'https://schema.org/FAQPage'
  },
  title: `${activeCategory.value.name} • Help • Bookchoice`,
  meta: [
    {
      name: 'description',
      content: activeCategory.value.metaDescription
    }
  ]
})

async function changeActiveCategory(category) {
  await navigateTo(`/help/${category.slug}`)
}

onMounted(() => {
  try {
    if (window.Intercom) {
      window.Intercom('update', {})
    }
    // eslint-disable-next-line no-empty
  } catch {}
})
</script>

<template>
  <section>
    <BasePageTitle :header="$label('settings.topNavItems.help')" />
    <Help
      v-if="categories.length"
      :categories="categories"
      :active-category="activeCategory"
      :active-question="activeQuestion"
      :change-active-category="changeActiveCategory"
    />
  </section>
</template>
